var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5014 13.9995H14.7114L14.4314 13.7295C15.0564 13.0035 15.5131 12.1483 15.769 11.2251C16.0248 10.3019 16.0735 9.33364 15.9114 8.38949C15.4414 5.60949 13.1214 3.38949 10.3214 3.04949C9.33706 2.92495 8.33723 3.02726 7.39846 3.34858C6.4597 3.66989 5.60688 4.20171 4.90527 4.90332C4.20366 5.60493 3.67185 6.45775 3.35053 7.39651C3.02921 8.33527 2.92691 9.3351 3.05144 10.3195C3.39144 13.1195 5.61144 15.4395 8.39144 15.9095C9.33559 16.0715 10.3039 16.0229 11.2271 15.767C12.1502 15.5112 13.0054 15.0544 13.7314 14.4295L14.0014 14.7095V15.4995L18.2514 19.7495C18.6614 20.1595 19.3314 20.1595 19.7414 19.7495C20.1514 19.3395 20.1514 18.6695 19.7414 18.2595L15.5014 13.9995ZM9.50144 13.9995C7.01144 13.9995 5.00144 11.9895 5.00144 9.49949C5.00144 7.00949 7.01144 4.99949 9.50144 4.99949C11.9914 4.99949 14.0014 7.00949 14.0014 9.49949C14.0014 11.9895 11.9914 13.9995 9.50144 13.9995Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8e51980ea064c98761a6bade82ac4780.svg";
export { ForwardRef as ReactComponent };